// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ExpandableClamp__label":"bch_a bih_hi bih_sa bih_xl"};